import moment, { Moment } from 'moment';

export function getDateRangeArray(dateStart?: any, dateEnd?: any, iterateBy: string = 'day') {
  dateStart = dateStart ? moment(dateStart) : moment();
  dateEnd = dateEnd ? moment(dateEnd) : moment();
  const dateValues = [];
  while (dateStart.isSameOrBefore(dateEnd) ) {
     dateValues.push(dateStart.format('YYYY-MM-DD'));
     dateStart.add(1, iterateBy);
  }
  return dateValues;
}

export function formatTime(timeInMillis: number) {
  let result = '';
  let secs;

  if (timeInMillis) {
    secs = timeInMillis / 1000;
    const hours = secs / 3600;
    secs = secs % 3600;
    const mins = secs / 60;
    secs = secs % 60;

    if (hours >= 1) {
      result = `${Math.floor(hours)}h `;
      if (mins >= 1) {
        result += `${Math.floor(mins)}m`;
      }
    } else {
      if (mins >= 1) {
        result = `${Math.floor(mins)}m `;
      }
      if (secs >= 1) {
        result += `${Math.floor(secs)}s`;
      }
    }
  } else {
    result = '--';
  }

  return result;
}

export function formatFullTime(timeInMillis: number) {
  let result = '';
  let secs;

  if (timeInMillis) {
    secs = timeInMillis / 1000;
    const hours = secs / 3600;
    secs = secs % 3600;
    const mins = secs / 60;
    secs = secs % 60;

    if (hours >= 1) {
      result = `${Math.floor(hours)}hours `;
      if (mins >= 1) {
        result += `${Math.floor(mins)}minutes`;
      }
    } else {
      if (mins >= 1) {
        result = `${Math.floor(mins)}minutes `;
      }
      if (secs >= 1) {
        result += `${Math.floor(secs)}seconds`;
      }
    }
  } else {
    result = '--';
  }

  return result;
}

export function subtractMonth(curDate: any = moment(), numberOfMonth: number = 1) {
  return moment(curDate).subtract(numberOfMonth, 'month').format('YYYY-MM-DD');
}

export function addMonth(curDate: any = moment(), numberOfMonth: number = 1) {
  return moment(curDate).add(numberOfMonth, 'month').format('YYYY-MM-DD');
}

export function getWeekRangeByMonth(
  month: string | number | Moment = moment().format('MM'),
  year: string | number = moment().format('YYYY'),
  tillCurrentWeek: boolean = false,
) {
  month = moment(`${year}-${month}`, 'YYYY-MM');
  let startDate = moment(month).startOf('month');
  const endDate = moment(month).endOf('month');

  const startOfWeekInMonth = startDate.isoWeek();
  let endOfWeekInMonth = endDate.isoWeek();
  let currentWeek = moment().isoWeek();
  if (endOfWeekInMonth < startOfWeekInMonth) {
    endOfWeekInMonth = moment(`${year}-12-31`).isoWeeksInYear();
    currentWeek = moment(`${year}-12-31`).isoWeeksInYear();
  }

  const endWeekNumber = tillCurrentWeek ? Math.min(currentWeek, endOfWeekInMonth) : endOfWeekInMonth;
  const weekRangeByMonth = [];

  let weekCounter = 1;
  while (startDate.isBefore(endDate)) {
    const weekStart = moment(startDate);
    let weekEnd = moment(startDate).endOf('isoWeek');

    if (weekEnd.isAfter(endDate)) {
      weekEnd = endDate;
    }

    weekRangeByMonth.push({
      week: weekStart.isoWeek(),
      weekLabel: `Week ${weekCounter}`,
      startDate: weekStart.format('YYYY-MM-DD'),
      endDate: weekEnd.format('YYYY-MM-DD'),
    });

    startDate = weekEnd.add(1, 'day');
    weekCounter++;
  }
  return weekRangeByMonth;
}
